import PropTypes from 'prop-types';
import { BaseComponent } from '../../../components/BaseComponent';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
  fetchInvoice,
  finalizeV2,
  retryFinalizationV2,
  updateInvoice,
  updateInvoiceOutgoingBpm,
} from '../../Invoices/actions';
import { selectInvoice } from '../../Invoices/selectors';
import {selectConfig, selectWorks} from '../../Api/selectors';
import {
  FINALIZATION_STATUSES,
  INVOICES_DOMAIN,
  INVOICE_DIRECTIONS,
  REQUEST_EXACT_EXPORT_INVOICE,
  REQUEST_INVOICE,
  REQUEST_UPDATE_INVOICE,
  REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
} from '../../Invoices/constants';
import { Loader } from '../../../components/Loader';
import { VBox } from '../../../components/Box';
import { getErrorStep, getFinalizationStatus } from '../../Invoices/helpers';
import styled from 'styled-components';
import { OutgoingBPMModal } from '../../Invoices/components/OutgoingBPMModal';
import { Button } from '../../../components/Buttons';
import { setVehicleProperty } from '../../Vehicles/actions';
import styles from './InvoiceFinalizationSection.module.css'

const ERROR = styled.div`
  border: 1px solid #fa5c7c;
  border-radius: 0.375rem;
  padding: 5px 10px;
  color: red;
  margin: 8px 0;
`;

const DONE = styled.div`
  border: 1px solid var(--color-new-secondary);
  border-radius: 0.375rem;
  padding: 5px 10px;
  margin: 8px 0;
`;

const IN_PROGRESS = styled.div`
  border: 1px solid #727cf5;
  border-radius: 0.375rem;
  padding: 5px 10px;
  margin: 8px 0;
`;

const STATE = {
  bpmUpdateModal: false,
  invoice: {},
};

/* eslint-disable react/prefer-stateless-function */
class InvoiceFinalizationSectionComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {
      this.setState({ invoice: result });
    });
  }

  get invoice() {
    // return this.props.FIN_kanban_modal ? this.state.invoice : this.props.invoice;
    return this.props.invoice;
  }
  get needToUpdateOutgoingBPM() {

    if (this.props.serverConfig?.disableBPM) return false;
    if (this.invoice?.type !== 'invoice') return false;
    if (this.invoice?.type !== 'invoice') return false;
    

    if (this.invoice?.vehicle?.vehiclePurpose == 'commercial') return false;

 
    return (
      
      this.invoice?.direction === 'outgoing' &&
      ((this.invoice?.subjectType === 'vehicle' && !this.invoice.ledgersEntry.needBPMInvoice) ||
        this.invoice?.subjectType === 'BPM') &&
      !this.invoice?.vehicle?.new_from_factory &&
      this.invoice?.vehicle?.vehiclePurpose !== 'commercial' &&
      this.invoice?.vehicle?.financialAmounts?.rest_bpm != 0
    );
  }

  onConfirmBPMModal(value) {
    this.setState({ bpmUpdateModal: false });
    this.props.updateInvoiceOutgoingBpm(value, data => {
      if (data.success) {
        this.props.finalizeV2(this.invoice?.vehicleId);
      }
    });
  }
  renderOutgoingBPMModal() {
    if (!this.state.bpmUpdateModal) return '';
    return (
      <OutgoingBPMModal
        invoice={this.invoice}
        onConfirm={this.onConfirmBPMModal.bind(this)}
        onCancel={() => this.setState({ bpmUpdateModal: false })}
      />
    );
  }

  finalizeV2() {
    if (this.needToUpdateOutgoingBPM && !this.props.FIN_kanban_modal) {
      this.setState({ bpmUpdateModal: true });
      return;
    }
    this.props.finalizeV2(this.invoice?.vehicleId);
  }

  renderFinalizeBtn() {
    const status = getFinalizationStatus(this.invoice);
    if (FINALIZATION_STATUSES.READY_TO_INITIATE === status)
      return (
        <Button className={this.props.className} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.DONE === status)
      return (
        <Button className={this.props.className} disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.IN_PROGRESS === status)
      return (
        <Button className={this.props.className} disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </Button>
      );

    if (FINALIZATION_STATUSES.ERROR === status)
      return (
        <Button className={this.props.className} onClick={() => this.props.retryFinalizationV2(this.invoice?.vehicleId)}>
          {this.lbl('invoice.details.retryFinalizeV2Btn')}
        </Button>
      );

    return '';
  }

  getDoneMsg(status) {
    return (
      <DONE>
        <p className="m-0">{this.lbl(`invoice.details.finalizationStatus.${status}`)}</p>
      </DONE>
    );
  }

  getInProgressMessage(status) {
    return (
      <IN_PROGRESS>
        <p className="m-0">{this.lbl(`invoice.details.finalizationStatus.${status}`)}</p>
      </IN_PROGRESS>
    );
  }
  getErrorSectionMsg(errorStep) {
    return (
      <ERROR>
        <p>Failed to make the invoice {errorStep.stepName}</p>
        <p>Error:</p>
        <p className="m-0">{errorStep.error}:</p>
      </ERROR>
    );
  }

  getStatusMsg = () => {
    let status = getFinalizationStatus(this.invoice);

    if (FINALIZATION_STATUSES.ERROR === status) {
      const errorStep = getErrorStep(this.invoice);
      return this.getErrorSectionMsg(errorStep);
    }
    if (FINALIZATION_STATUSES.DONE === status) return this.getDoneMsg(status);
    if (FINALIZATION_STATUSES.IN_PROGRESS === status) return this.getInProgressMessage(status);

    return '';
  };

  render() {
    if (!this.invoice?.id) return <p>No invoice</p>;
    if (this.props.work) return <Loader small />;

    return (
      <VBox className={styles.buttonTextBox}>
        {this.renderFinalizeBtn()}
        {this.getStatusMsg()}
        {this.renderOutgoingBPMModal()}
      </VBox>
    );
  }
}

InvoiceFinalizationSectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_INVOICE,
      REQUEST_EXACT_EXPORT_INVOICE,
      REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
      REQUEST_UPDATE_INVOICE,
    ]),
    invoice: selectInvoice(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoice_id, callback));
    },
    finalizeV2(vehicleId) {
      if (vehicleId) {
        dispatch(setVehicleProperty(vehicleId, 'outgoing_invoice_in_progress', '1'));
      }
      dispatch(finalizeV2(ownProps.invoice_id));
    },
    retryFinalizationV2(vehicleId) {
      if (vehicleId) {
        dispatch(setVehicleProperty(vehicleId, 'outgoing_invoice_in_progress', '1'));
      }
      dispatch(retryFinalizationV2(ownProps.invoice_id));
    },
    updateInvoiceOutgoingBpm(value, callback) {
      dispatch(updateInvoiceOutgoingBpm(ownProps.invoice_id, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceFinalizationSection = compose(withConnect, withRouter)(InvoiceFinalizationSectionComp);
